module.exports = __webpack_public_path__ + "static/img/blog-04.a0a013b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog/blog-04.jpg
// module id = 0LTs
// module chunks = 7